module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/list-a4544d863ae83f8e5148808a440c52e5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/list.svg
// module id = sDae
// module chunks = 24